// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uHI_","colMin":"styles_colMin__11zjT"};